<template>
  <div id="contactrels-list" :class="[$mq]" v-if="$mq != 'portrait'">
    <div class="title">{{ $t("contact-rel-list") }}</div>
    <div class="clear" style="height: 20px"></div>
    <div class="contact_list">
      <div v-for="(contact_rel, key) in contacts_rel" :key="contact_rel.id">
        <TeamCard
          v-if="is_team(contact_rel)"
          :team="team(contact_rel)"
          :event="event(contact_rel)"
          :role="contact_rel.contact_type"
          :is_rel="true"
          :id_rel="contact_rel.id"
        ></TeamCard>
        <ClubCard
          v-else-if="is_club(contact_rel)"
          :club="club(contact_rel)"
          :role="contact_rel.contact_type"
          :is_rel="true"
          :id_rel="contact_rel.id"
        ></ClubCard>
      </div>
    </div>
  </div>
</template>

<script>
import i18n from "@/i18n";
import TeamCard from "@/components/ui/cards/mini/Team";
import ClubCard from "@/components/ui/cards/mini/Club";

export default {
  components: { TeamCard, ClubCard },
  props: { contacts_rel: Array },
  data() {
    return {};
  },
  computed: {},
  methods: {
    is_club(contact_rel) {
      return contact_rel.club !== null;
    },
    is_team(contact_rel) {
      return contact_rel.team !== null;
    },
    club(contact_rel) {
      return contact_rel.club;
    },
    team(contact_rel) {
      return contact_rel.team;
    },
    event(contact_rel) {
      return contact_rel.event;
    },
  },
  created() {
    var self = this;
  },

  filters: {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
#contactrels-list {
  background-color: $complem-color-light;
  position: fixed;
  top: calc(#{$header-height} + #{$topbar-height});
  right: 0;
  height: calc(100% - #{$header-height} - #{$topbar-height});
  overflow-y: auto;
  border-left: 5px solid #fff;

  .title {
    padding-bottom: 5px;
    background: url("/img/users.svg") no-repeat left 10px center;
    background-size: 15px;
    padding-left: 35px;
  }
}

.development #contactrels-list {
  top: calc(#{$header-height} + #{$topbar-height} + #{$height-development});
}
</style>
